import {
  PRIVILEGE_FETCH,
  PRIVILEGE_FETCH_SUCCESS,
  PRIVILEGES_FETCH,
  PRIVILEGES_FETCH_SUCCESS,
  PRIVILEGES_FETCH_ALL,
} from "./types";

export const privilegeFetch = (payload) => {
  return {
    type: PRIVILEGE_FETCH,
    payload: payload,
  };
};

export const privilegeFetchSuccess = (payload) => {
  return {
    type: PRIVILEGE_FETCH_SUCCESS,
    payload: payload,
  };
};

export const privilegesFetch = (payload) => {
  return {
    type: PRIVILEGES_FETCH,
    payload: payload,
  };
};

export const privilegesFetchAll = (payload) => {
  return {
    type: PRIVILEGES_FETCH_ALL,
    payload: payload,
  };
};



export const privilegesFetchSuccess = (payload) => {
  return {
    type: PRIVILEGES_FETCH_SUCCESS,
    payload: payload,
  };
};
